import log from "cslog";
import React from "react";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import styles from "./styles/LoopBuilder.module.css";
import ElementStaticView from "../../ElementStaticView";

// TODO send it to elements/widgets folder
function LoopBuilder({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];

    //=========================
    const ps = parseStyle(data, gs, data.cstate);
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    //=========================

    let input = ps.input;

    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const all_style = {
        ...fixStyle,
        ...style,
        textAlign: input.textAlign,
        fontWeight: input.bold ? "bold" : "normal",
        textTransform: input.uppercase ? "uppercase" : "none",
        ...(tablet(device) && styleTab),
        ...(mobile(device) && styleMob),
        outline: "none",
    };

    const childs = data.childs;
    let child = null;
    if (childs && childs.length > 0) {
        child = childs[0];
    }

    // log.d(dydb, "DyDB in LoopBuilder");
    const content = dydb[input.dataSource];
    // log.d(content, "Content LoopBuilder");

    const num = 5;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                className={styles.wrapper}
                style={{
                    gridTemplateColumns: `repeat(${
                        input.cardsPerRow || 3
                    }, 1fr)`,
                    gap: input.gap,
                }}
            >
                {content?.isSuccess &&
                    content?.data?.data?.map((item, index) => {
                        if (child) {
                            return (
                                <ElementStaticView
                                    key={index}
                                    id={child}
                                    index={0}
                                    db={db}
                                    gs={gs}
                                    device={device}
                                    dydb={{
                                        ...dydb,
                                        parent: item,
                                    }}
                                    ctx={{
                                        ...ctx,
                                        list: input.dataSource,
                                    }}
                                />
                            );
                        }
                    })}
                {/* {[...Array(num).keys()].map((item) => {
                    if (child) {
                        return (
                            <Element
                                key={child}
                                id={child}
                                index={0}
                                gs={gs}
                                dydb={{
                                    ...dydb,
                                    // parent: this child data
                                }}
                                ctx={{
                                    ...ctx,
                                    list: input.dataSource,
                                }}
                            />
                        );
                    }
                })} */}
                {/* 
                <div className={styles.item}>LoopBuilder</div>
                <div className={styles.item}>LoopBuilder</div> */}
            </div>
        </div>
    );
}

export default LoopBuilder;

// https://github.com/mattboldt/typed.js
// https://www.npmjs.com/package/react-typed
